module.exports = __webpack_public_path__ + "img/line-dotted.9ef70498.svg";